import { Injectable } from '@angular/core';
import { DetailedRoute } from '@ridango/components';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from '@ridango/core/lib/services/storage.service';
import { take } from 'rxjs/operators';

const STORAGE_KEY = 'pattern_schedule_route';

@Injectable({
    providedIn: 'root'
})
export class PatternScheduleSharedService {
    private routeSubject = new BehaviorSubject<DetailedRoute | null>(null);

    constructor(private storage: StorageService) {
        this.storage
            .getItem<DetailedRoute>(STORAGE_KEY)
            .pipe(take(1))
            .subscribe((route) => {
                if (route) {
                    this.routeSubject.next(route);
                }
            });
    }

    setRoute(route: DetailedRoute): void {
        this.storage
            .setItem(STORAGE_KEY, route)
            .pipe(take(1))
            .subscribe(() => {
                this.routeSubject.next(route);
            });
    }

    getRoute(): Observable<DetailedRoute | null> {
        return this.routeSubject.asObservable();
    }

    clearRoute(): void {
        this.storage
            .removeItem(STORAGE_KEY)
            .pipe(take(1))
            .subscribe(() => {
                this.routeSubject.next(null);
            });
    }
}
